import React from "react";

const SliderCarousel = () => {
  return (
    <div
      className="slider-wrap"
      style={{
        backgroundColor: "white", // Set the background color of the entire container
        padding: "20px", // Optional: Add padding to ensure spacing
      }}
        >
     
    </div>
  );
};

export default SliderCarousel;